import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { X } from 'lucide-react';
import { API_URL } from '../utils/apiUrl';

/**
 * TT-POPUP-001 — Anasayfa launch popup.
 * Görünürlük kuralları:
 *   1. localStorage'da 'tt_launch_popup_dismissed' yoksa
 *   2. Backend `/api/homepage/popup-visibility` `{show: true}` dönerse
 *      (yani sistemde aktif + geçerli rozetli ürün sayısı < 3 ise)
 *   3. Sayfa yüklendikten 2 saniye sonra açılır
 * Kullanıcı kapatınca localStorage'a yazılır ve o kişiye bir daha gösterilmez.
 */
const LS_KEY = 'tt_launch_popup_dismissed';

const AnnouncementPopup = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    // Daha önce kapatıldıysa çıkma
    if (typeof window !== 'undefined' && window.localStorage.getItem(LS_KEY)) return;

    let cancelled = false;
    axios.get(`${API_URL}/api/homepage/popup-visibility`)
      .then(({ data }) => {
        if (cancelled || !data?.show) return;
        // 2 saniye sonra aç
        setTimeout(() => { if (!cancelled) setOpen(true); }, 2000);
      })
      .catch(() => { /* sessiz — hata olursa popup gösterme */ });

    return () => { cancelled = true; };
  }, []);

  const dismiss = () => {
    try { window.localStorage.setItem(LS_KEY, '1'); } catch { /* ignore */ }
    setOpen(false);
  };

  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-[60] flex items-center justify-center px-4 bg-black/50"
      onClick={(e) => { if (e.target === e.currentTarget) dismiss(); }}
      data-testid="launch-popup-backdrop"
      role="dialog"
      aria-modal="true"
      aria-labelledby="launch-popup-title"
    >
      <div
        className="relative w-full max-w-md rounded-2xl shadow-2xl overflow-hidden"
        style={{ background: '#FFFFFF' }}
        data-testid="launch-popup"
      >
        {/* Kapat butonu */}
        <button
          type="button"
          onClick={dismiss}
          aria-label="Kapat"
          className="absolute top-3 right-3 w-8 h-8 rounded-full flex items-center justify-center hover:bg-neutral-100 transition-colors z-10"
          data-testid="launch-popup-close"
        >
          <X className="w-4 h-4" style={{ color: '#1C3B2A' }} />
        </button>

        {/* Üst yeşil bant */}
        <div className="h-2" style={{ background: '#1C3B2A' }} />

        <div className="px-6 md:px-8 py-8 text-center">
          <h2
            id="launch-popup-title"
            className="text-xl md:text-2xl font-black tracking-tight mb-4"
            style={{ color: '#1C3B2A' }}
            data-testid="launch-popup-title"
          >
            🎉 TestettiK Testleri Başladı!
          </h2>
          <p
            className="text-[15px] leading-relaxed font-medium mb-6"
            style={{ color: '#374151' }}
            data-testid="launch-popup-body"
          >
            Bağımsız ürün testlerimiz başladı. İlk sonuçlar yakında burada. Takipte kal, ilk sonuçları kaçırma.
          </p>
          <button
            type="button"
            onClick={dismiss}
            className="inline-flex items-center justify-center px-6 py-3 rounded-lg text-white text-sm font-bold hover:opacity-90 transition-opacity focus-visible:ring-2 focus-visible:ring-offset-2 outline-none"
            style={{ background: '#1C3B2A' }}
            data-testid="launch-popup-cta"
          >
            Tamam, Takipteyim
          </button>
        </div>
      </div>
    </div>
  );
};

export default AnnouncementPopup;
